
<template>
  <div class="grid-content">
    <div class="box parentflex">
      <p>今日单片能耗</p>
      <div class="count">
        <div class="box">
          <div class="pagebox">
            <div id="ganuge"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    threedata: {
      //echarts数据
      type: Array, //类型只能是数组
      default: () => {
        return [];
      }
    },
    chartMaxMinData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      myChart: ""
    };
  },
  watch: {
    threedata(curval) {
      this.fillGanuge(curval);
    }
  },
  methods: {
    fillGanuge(obj) {
      //罗盘
      let this_ = this;
      if (
        this_.myChart != null &&
        this_.myChart != "" &&
        this_.myChart != undefined
      ) {
        this_.myChart.dispose();
      }
      this_.myChart = this_.$echarts.init(document.getElementById("ganuge"));
      var option = {
        tooltip: {
          formatter: "{a} <br/>{c} {b}"
        },
        series: [
          {
            title: "单片用电量",
            name: "单片用电量",
            type: "gauge",
            z: 3,
            min: this_.chartMaxMinData.right.min,
            max: this_.chartMaxMinData.right.max,
            splitNumber: 10,
            center: ["74%", "48%"], // 默认全局居中
            radius: "95%",
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 6
              }
            },
            axisTick: {
              // 坐标轴小标记
              length: 10, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto"
              }
            },
            splitLine: {
              // 分隔线
              length: 12, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "auto"
              }
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [this_.chartMaxMinData.right.oneMax, "#91c7ae"],
                  [this_.chartMaxMinData.right.twoMax, "#63869e"],
                  [1, "#c23531"]
                ],
                width: 6
              }
            },
            axisLabel: {
              backgroundColor: "auto",
              borderRadius: 2,
              color: "#eee",
              padding: 3,
              textShadowBlur: 2,
              textShadowOffsetX: 1,
              textShadowOffsetY: 1,
              textShadowColor: "#222"
            },
            title: {
              offsetCenter: [0, "95%"] // x, y，单位px
            },
            pointer: {
              width: 5 //罗盘指针宽度
            },
            detail: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            //   formatter: function(value) {
            //     value = (value + "").split(".");
            //     value.length < 3 && value.push("00");
            //     return ("00" + value[0]).slice(-3) +
            //       "." +
            //       (value[1] + "00").slice(0,2)
            //     ;
            //   },
            //   formatter: function(value) {
            //     value = (value + "").split(".");
            //     value.length < 2 && value.push("00");
            //     return (
            //       ("00" + value[0]).slice(-2) +
            //       "." +
            //       (value[1] + "00").slice(0, 2)
            //     );
            //   },
              //		                fontWeight: 'bolder',
              //		                borderRadius: 3,
              backgroundColor: "#444",
              borderColor: "#aaa",
              shadowBlur: 5,
              shadowColor: "#333",
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              borderWidth: 2,
              textBorderColor: "#000",
              textBorderWidth: 2,
              textShadowBlur: 2,
              textShadowColor: "#fff",
              textShadowOffsetX: 0,
              textShadowOffsetY: 0,
              fontSize: "12",
              fontFamily: "Arial",
              offsetCenter: [0, "60%"],
              width: 50,
              color: "#eee",
              rich: {}
            },
            data: [{ value: obj[0], name: "单片用电量\n(kW▪h/万片)" }]
          },
          {
            title: "单片综合能耗",
            name: "单片综合能耗",
            type: "gauge",
            z: 3,
            min: this_.chartMaxMinData.left.min,
            max: this_.chartMaxMinData.left.max,
            splitNumber: 10,
            center: ["26%", "48%"], // 默认全局居中
            radius: "95%",
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 8
              }
            },
            axisTick: {
              // 坐标轴小标记
              length: 10, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto"
              }
            },
            splitLine: {
              // 分隔线
              length: 12, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "auto"
              }
            },
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: [
                  [this_.chartMaxMinData.left.oneMax, "#91c7ae"],
                  [this_.chartMaxMinData.left.twoMax, "#63869e"],
                  [1, "#c23531"]
                ],
                width: 8
              }
            },
            axisLabel: {
              backgroundColor: "auto",
              borderRadius: 2,
              color: "#eee",
              padding: 3,
              textShadowBlur: 2,
              textShadowOffsetX: 1,
              textShadowOffsetY: 1,
              textShadowColor: "#222"
            },
            title: {
              offsetCenter: [0, "95%"] // x, y，单位px
            },
            pointer: {
              width: 5 //罗盘指针宽度
            },
            detail: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              //   formatter: function(value) {
              //     value = (value + "").split(".");
              //     value.length < 2 && value.push("00");
              //     return (
              //       ("00" + value[0]).slice(-2) +
              //       "." +
              //       (value[1] + "00").slice(0, 2)
              //     );
              //   },
              //		                fontWeight: 'bolder',
              //		                borderRadius: 3,
              backgroundColor: "#444",
              borderColor: "#aaa",
              shadowBlur: 5,
              shadowColor: "#333",
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              borderWidth: 2,
              textBorderColor: "#000",
              textBorderWidth: 2,
              textShadowBlur: 2,
              textShadowColor: "#fff",
              textShadowOffsetX: 0,
              textShadowOffsetY: 0,
              fontSize: "12",
              fontFamily: "Arial",
              offsetCenter: [0, "60%"],
              width: 50,
              color: "#eee",
              rich: {}
            },
            data: [{ value: obj[1], name: "单片综合能耗\n(kgce/万片)" }]
          }
        ]
      };
      this_.myChart.setOption(option, true);
      if (this_.myChart) {
        window.addEventListener("resize", function() {
          this_.myChart.resize();
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.grid-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 10px 2px #ccd7e8;
  border: 1px solid #ccd7e8;
  border-radius: 10px;
   text-align: left;
}
.count {
  position: absolute;
  top: 2.3rem;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  box-shadow: 0 0 10px 2px #ccd7e8;
  box-sizing: border-box;
}
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
  background: #fff;
}
.pagebox {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
#ganuge {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.parentflex {
  position: relative;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
  padding-top: 1px;
}
.parentflex > p {
  width: 100%;
  height: 2.2rem;
  line-height: 2.2rem;
  font-size: 1.4rem;
  padding-left: 1rem;
  font-weight: bold;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>